var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import useFile from '../../../../core/hooks/useFile';
import { VideoFileStatus, VideoQuality, MP4MimeType } from '../../../../social/constants';
import StyledVideo from './styles';
const DistantVideo = (_a) => {
    var { fileId } = _a, props = __rest(_a, ["fileId"]);
    const file = useFile(fileId);
    if (!file.fileId)
        return null;
    let { fileUrl } = file;
    let { mimeType } = file.attributes;
    /*
     * It's possible that certain video formats uploaded by the user are not
     * playable by the browser. So it's best to use the transcoded video file
     * which is an mp4 format to play video.
     *
     * Note: the below logic needs to be smarter based on users bandwidth and also
     * should be switchable by the user, which would require a ui update
     */
    if (file.status === VideoFileStatus.Transcoded) {
        const { videoUrl } = file;
        switch (true) {
            case videoUrl.hasOwnProperty(VideoQuality.FHD):
                fileUrl = videoUrl[VideoQuality.FHD];
                break;
            case videoUrl.hasOwnProperty(VideoQuality.HD):
                fileUrl = videoUrl[VideoQuality.HD];
                break;
            case videoUrl.hasOwnProperty(VideoQuality.SD):
                fileUrl = videoUrl[VideoQuality.SD];
                break;
            case videoUrl.hasOwnProperty(VideoQuality.LD):
                fileUrl = videoUrl[VideoQuality.LD];
                break;
            default:
                fileUrl = videoUrl[VideoQuality.Original];
                break;
        }
        if (!fileUrl.includes(VideoQuality.Original))
            mimeType = MP4MimeType;
    }
    return React.createElement(StyledVideo, Object.assign({ url: fileUrl, mimeType: mimeType }, props));
};
DistantVideo.propTypes = {
    fileId: PropTypes.string.isRequired,
};
export default DistantVideo;
//# sourceMappingURL=DistantVideo.js.map